/**
 * Base Filter class
 */
class Filter {
  constructor({
    containerId = '',
    searchParameter = '',
    options = null,
    updateCallback = null,
    searchParameters,
    selected,
  } = {}) {
    this.containerId = containerId;
    this.searchParameter = searchParameter;
    this.options = options;
    this.updateCallback = updateCallback;
    this.searchParameters = searchParameters;
    this.selected = selected;
  }
}

export default Filter;
